import React, { useContext } from 'react';
import {
  Autoplay,
} from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import API_URL from '../../services';

import 'swiper/css';
import '../../assets/styles/swipper-style.css';
import { LandingPageData } from '../../contexts/LandingPageContext';

export default function PartnerCrousel() {
  const { data: { partner: partnerList } } = useContext(LandingPageData);
  const isAvailable = Boolean(partnerList.length);

  function Partners() {
    return (
      <>
        {isAvailable && (
          <Swiper
            spaceBetween={10}
            slidesPerView={5}
            loop
            centeredSlides
            autoplay={{
              delay: 2500,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            className="mySwiper"
          >
            {partnerList.map((value) => (
              <SwiperSlide className="w-[150px]" key={`${value.name}${value.key}`}>
                <img src={`${API_URL}${value.logo}`} alt="..." className="object-scale-down xs:max-w-[100px]" />
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </>
    );
  }

  return (
    <div className="bg-white py-12 mb-5">
      <h1 className="text-center text-main font-lato p-5">Trusted Partenres</h1>
      <hr />
      <br />
      <div className="my-5">
        <Partners />
      </div>
    </div>
  );
}
